import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DetailCheckbox } from "@/components/ui/checkbox"
import { BetterDocSearchBaseFormType } from "@/modules/patients/detail/better-doc/schema/better-doc-search-base-schema"

export const BetterDocConsent = () => {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext<BetterDocSearchBaseFormType>()

  return (
    <div className="grid gap-4">
      <div className="text-on-surface text-base leading-6 font-medium">
        {t("episodeOfCare.betterDoc.searchDialog.consent")}
      </div>
      <Controller
        control={control}
        name="transferDataConsent"
        render={({ field: { value, onChange } }) => {
          return (
            <DetailCheckbox
              error={!!errors.transferDataConsent?.message}
              checked={value}
              onCheckedChange={onChange}
              testId="transfer-data-consent">
              {t("episodeOfCare.betterDoc.searchDialog.transferDataConsent")}
            </DetailCheckbox>
          )
        }}
      />
    </div>
  )
}
